export const reduxRequest = async (
  dispatch,
  prefixAction,
  service,
  options = {
    isAllRequest: false,
    requestDispatchData: {},
    successDispatchData: {},
    errorDispatchData: {},
  }
) => {
  const {
    requestDispatchData,
    successDispatchData,
    errorDispatchData,
    isAllRequest,
  } = options;
  dispatch({ type: prefixAction, ...requestDispatchData });
  try {
    const response = await service;

    let payload = null;
    if (isAllRequest) {
      payload = [];
      response.forEach(({ data }) => {
        payload.push(data);
      });
    } else {
      payload = response?.data?.data || response?.data || null;
    }
    dispatch({
      type: getSuccessActionType(prefixAction),
      successDispatchData,
      payload,
    });
  } catch (error) {
    dispatch({
      type: getErrorActionType(prefixAction),
      error: error.response,
      errorDispatchData,
    });
  }
};

export const getSuccessActionType = (action) => {
  return `${action}.SUCCESS`;
};
export const getErrorActionType = (action) => {
  return `${action}.ERROR`;
};

export const getClearActionType = (action) => {
  return `${action}.CLEAR`;
};
